import React, { useEffect } from "react";
import useLogin from "./useLogin.js";
import OTPInput from "../../Components/OTPInput";

export default function EmailVerificationModal({ open, onClose }) {
  const {
    showOtpForm,
    otp,
    setOtp,
    onOtpSubmit,
    otpError,
    otpSuccess,
    resendLoading,
    onResendOtp,
    onSkip
  } = useLogin({ isModal: true, closeVerificationModal:onClose });
useEffect(()=>{
open&&onResendOtp()
},[open])
  if (!open) return null;

  return (
    <div
      onClick={onClose}
      className="modal bg-black/60 h-screen fixed left-0 flex justify-center items-center top-0 w-full z-40 px-6 py-3 md:px-10"
    >
      <div
        className="bg-blueGray border-2 border-borderGray p-6 px-4 md:px-8 rounded-md max-w-lg w-full my-auto md:mx-auto shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <form onSubmit={onOtpSubmit} className="bg-transparent py-6 text-white">
          <h1 className="mb-3 text-2xl font-bold text-center text-white">Verify Your Email</h1>
          <p className="text-center text-gray-300 mb-6 text-sm">
            A verification code has been sent to <strong className="text-white">your email</strong>. Please enter the code below.
          </p>

          <OTPInput value={otp} onChange={setOtp} length={6} disabled={resendLoading} />

          {otpError && <div className="text-red-400 mb-2 text-center">{otpError}</div>}
          {otpSuccess && <div className="text-green-400 mb-2 text-center">{otpSuccess}</div>}

          <div className="flex flex-col justify-center items-center w-full mt-6 space-y-3">
            <button
              type="submit"
              className="uppercase w-full p-3 rounded-md bg-primaryBlue hover:bg-primaryBlue/90 text-white font-medium transition-colors disabled:opacity-50"
              disabled={otp.length !== 6}
            >
              Verify Email
            </button>

            <button
              type="button"
              onClick={onResendOtp}
              className="w-full p-2 rounded-md bg-[#384355] border border-borderGray text-white hover:bg-gray-600 transition-colors disabled:opacity-50"
              disabled={resendLoading}
            >
              {resendLoading ? "Resending..." : "Resend OTP"}
            </button>

            {/* <button
              type="button"
              onClick={onSkip}
              className="text-sm text-gray-400 hover:text-white transition"
            >
              Skip for now
            </button> */}

            <button
              type="button"
              onClick={onClose}
              className="text-sm text-gray-400 hover:text-white transition-colors"
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
